import { render } from "./eventManagement.vue?vue&type=template&id=8fb68d5c&scoped=true"
import script from "./eventManagement.vue?vue&type=script&lang=js"
export * from "./eventManagement.vue?vue&type=script&lang=js"

import "./eventManagement.vue?vue&type=style&index=0&id=8fb68d5c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8fb68d5c"

export default script